type PlayerRouteParams =
  | { event: string; referrer?: string }
  | { video: string; referrer?: string }
  | { content: string; referrer?: string }

/**
 * Builds a URL for the player page.
 *
 * Accepts exactly one content identifier (`event`, `video`, or `content`)
 * and an optional `referrer` for back-navigation.
 *
 * @example
 * playerRoute({ event: '123' })                        // '/player?e=123'
 * playerRoute({ video: '456', referrer: '/calendar' })  // '/player?v=456&referrer=%2Fcalendar'
 * playerRoute({ content: '789', referrer: '/' })         // '/player?c=789&referrer=%2F'
 */
export const playerRoute = (params: PlayerRouteParams): string => {
  const searchParams = new URLSearchParams()

  if ('event' in params) searchParams.set('e', params.event)
  if ('video' in params) searchParams.set('v', params.video)
  if ('content' in params) searchParams.set('c', params.content)
  if (params.referrer) searchParams.set('referrer', params.referrer)

  return `/player?${searchParams.toString()}`
}
